<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">新增用户</h1>
            <el-form class="form-container" :model="userInfo" :rules="userRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">姓名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入姓名"  v-model="userInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">用户名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="account">
                            <el-input placeholder="请输入用户名"  v-model="userInfo.account">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <p class="remark">注:用户将使用该用户名登录系统</p>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">密码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="password">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">确认密码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="password_confirm">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password_confirm" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">角色</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="role_id">
                            <role-auto-complete v-model="userInfo.role_id" :factor-id="1" :status="0" :limit="20"></role-auto-complete>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { addAdmin } from '@/service/user'
    import {validatePassword, validateMobile,validateChat} from '@/utils/validate'
    import RoleAutoComplete from "../../../../components/auto-complete/role-auto-complete";
    export default {
        name: "add",
        components: {
            RoleAutoComplete,
            PopoverRight
        },
        props: {
            callback: Function
        },
        data () {
            let validPasswordConfirm = (rule,value,callback) => {
                if (!value || value != this.userInfo.password) {
                    callback(new Error("确认密码与密码不一致"))
                } else {
                    callback()
                }
            }
            return {
                userInfo: {
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                    role_id : '',
                },
                options : [],
                userRules: {
                    name: [
                        { required: true, message: '请填写名称', trigger: 'blur' },
                        { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' },
                        {validator:validateChat,type:4, trigger: 'blur',result:'姓名'}
                    ],
                    role_id: [
                        { required: true, message: '请填写角色', trigger: 'blur' }
                    ],
                    password : [
                        { validator:validatePassword, result: '密码',trigger: 'blur' }
                    ],
                    password_confirm : [
                        { validator:validPasswordConfirm, trigger: 'blur' }
                    ],
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 6, max: 25, message: '用户名长度为6-25字符', trigger: 'blur' },
                        { validator: validateChat, type: 6, result: '用户名', trigger: 'blur' }
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            resetForm () {
                this.userInfo = {
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                    role_id : '',
                }
                this.options = []
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        addAdmin(this.userInfo).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
